import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from './core/services/data.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavComponent, FooterComponent, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'encounters';

  constructor(
    private _DataService: DataService,
    private spinner: NgxSpinnerService
  ) {}
  phoneNumber: any;
  ngOnInit(): void {
    this.getSettings();
  }

  getSettings(): void {
    this._DataService.getSetting().subscribe({
      next: (res) => {
        // const settings = res.data; // بافتراض إن res.data Array من الـ Items
        const contactItem = res.data.find(
          (item: any) => item.option_key === 'CONTACT_PHONE_NUMBER'
        );
        this.phoneNumber = 'https://wa.me/' + contactItem?.option_value[0];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
